import { Injectable } from '@angular/core';
import {initializeApp, FirebaseApp} from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FireService {
    get app() {
        return this.instance;
    }

    private instance!: FirebaseApp;
    private initialized = false;

    constructor() {}

    public async init(): Promise<void> {
        if (this.initialized) {
            console.error('Tried to initialize Firebase again. Aborted.');
            return;
        }
        this.initialized = true;

        const configPath = environment.production
            ? '/__/firebase/init.json'
            : '/firebase-projects/__/firebase-config.localhost.json';
        const configReponse = await fetch(configPath);
        const config = await configReponse.json();
        this.instance = initializeApp(config);
    }
}